module.exports = __webpack_public_path__ + "img/4.d024c20f.svg";